import occasions from './occasions'
import countryOccasions from './country-occasions'
import { IDayCell } from './calendar'
import { CalendarSystem } from './settings'

// Which colour a holiday takes, decided in one place so the grid, the month
// list, the day page, the year view and the widget cannot drift apart again.
//
// The holiday colour means "a day off in the calendar you are reading". The
// other colour means "a day off in the other one". So an Iranian living in the
// Netherlands reading the Jalaali grid sees Nowruz in red and King's Day in
// blue; switching to the Gregorian grid trades the two over. A day that is both
// stays red — the calendar on screen wins.
//
// Only a statutory public holiday takes a colour at all. A day merely named in
// another country's law is listed, never coloured, because it is not a day off
// anywhere.

export type Source = 'iran' | 'abroad'

// Whether this side of the calendar is the one being read.
export const isPrimary = (from: Source, system: CalendarSystem) =>
    system === 'gregorian' ? from === 'abroad' : from === 'iran'

export interface IDayMarks {
    primary: boolean // the calendar on screen calls this a day off
    other: boolean // the other one does
}

// `isWeekend` comes from the grid, the only caller that knows a cell's column.
// Only the calendar on screen contributes its own weekend: tinting every
// Saturday on a Jalaali grid would be eight coloured days a month for something
// everyone already knows.
export function dayMarks(cell: IDayCell, system: CalendarSystem, isWeekend = false): IDayMarks {
    const iran = occasions.forDay(cell).some(o => o.isHoliday)
    const abroad = countryOccasions.forDay(cell).some(o => o.type === 'public_holiday')
    const iranLeads = isPrimary('iran', system)
    return {
        primary: isWeekend || (iranLeads ? iran : abroad),
        other: iranLeads ? abroad : iran,
    }
}
